module.exports = __webpack_public_path__ + "static/media/triangle-music.cfd652ee.svg";